import Work from "@/components/Work";
import CtaBand from "@/components/CtaBand";

export default function WorkPage() {
  return (
    <main data-testid="page-work" className="pt-[72px]">
      <Work />
      <CtaBand />
    </main>
  );
}
